import h5publicRouter from './h5/router.map'
// 路由配置
const options = {
  routes: h5publicRouter.routes
}

export default options
